import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const benefits = [{
  book: 'Reconocer el dolor sin culpa',
  life: 'Dejas de gastar energía en fingir que estás bien'
}, {
  book: 'Romper creencias limitantes',
  life: 'Dejas de sabotearte antes de intentarlo'
}, {
  book: 'Plan de 12 semanas',
  life: "Tienes un camino claro — no más 'no sé por dónde empezar'"
}, {
  book: 'Sección de relaciones y límites',
  life: 'Dejas de sentirte culpable por proteger tu paz'
}, {
  book: 'Propósito y testimonio',
  life: 'Tu historia deja de ser tu vergüenza — se convierte en tu poder'
}, {
  book: 'Rituales diarios espirituales',
  life: 'Hay algo que te sostiene cuando la motivación desaparece'
}];
export function BenefitsTranslation() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-[var(--cream)] py-24 md:py-32" data-id="element-72">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.8
    }} className="max-w-5xl mx-auto px-6" data-id="element-73">
        <div className="space-y-12" data-id="element-74">
          <h2 className="font-display text-4xl md:text-5xl text-[var(--dusk-purple)] text-center" data-id="element-75">
            Lo Que Esto Realmente Te Da
          </h2>

          <p className="text-xl text-[var(--charcoal)]/70 text-center italic" data-id="element-76">
            Beneficios traducidos a vida real
          </p>

          <div className="space-y-6" data-id="element-77">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="grid md:grid-cols-2 gap-6 items-center bg-white p-6 rounded-xl border-2 border-[var(--charcoal)]/10" data-id="element-78">
                <div className="space-y-1" data-id="element-79">
                  <p className="text-sm text-[var(--charcoal)]/60 uppercase tracking-wide font-semibold" data-id="element-80">
                    En el libro
                  </p>
                  <p className="text-lg font-semibold text-[var(--dusk-purple)]" data-id="element-81">
                    {benefit.book}
                  </p>
                </div>

                <div className="flex items-center gap-4" data-id="element-82">
                  <ArrowRight className="w-6 h-6 text-[var(--warm-gold)] flex-shrink-0 hidden md:block" data-id="element-83" />
                  <div className="space-y-1" data-id="element-84">
                    <p className="text-sm text-[var(--charcoal)]/60 uppercase tracking-wide font-semibold" data-id="element-85">
                      En tu día a día
                    </p>
                    <p className="text-lg text-[var(--charcoal)]" data-id="element-86">
                      {benefit.life}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </motion.div>
    </section>;
}